import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from 'store'
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  // 判断登录
  let token = store.state.app.token
  if (to.name !== 'login' && !token) {
    next({
      name: 'login',
      query: {
        redirect: to.name
      }
    })
  } else {
    next()
  }
})

export default router
